import type { FC } from 'react';
import { VyDialog } from '../../../../../../../components/new-design/feedback/VyDialog';
import { DIALOG_CONTENT_STYLE, DIALOG_LABEL, DIALOG_LABEL_DESCRIPTION, type NetSuiteSyncWizardProps } from '../types';
import { DialogLoadingFallback } from './DialogLoadingFallback';

export const NetSuiteSyncWizardDialogLoading: FC<Pick<NetSuiteSyncWizardProps, 'open' | 'onClose'>> = ({
  open,
  onClose,
}) => (
  <VyDialog
    open={open}
    onClose={onClose}
    label={DIALOG_LABEL}
    labelDescription={DIALOG_LABEL_DESCRIPTION}
    cancelButtonText="Cancel"
    ctaText="Next"
    ctaDisabled
    disableDividers
    dialogContentProps={{
      style: DIALOG_CONTENT_STYLE,
    }}
  >
    <DialogLoadingFallback />
  </VyDialog>
);

